import React from 'react'
import PropTypes from 'prop-types'

import './AlertBox.scss'

const AlertBox = ({ children, type="normal" }) => 
	children ? <div className="AlertBox" data-type={type} >{children}</div> : '';

AlertBox.propTypes = {
	children: PropTypes.node,
}

export default AlertBox


// WEBPACK FOOTER //
// ./src/components/AlertBox/AlertBox.jsx